import React from "react";

export default function StrongText({ children = "" }) {
  const parts = String(children).split(/(<strong>.*?<\/strong>)/gi);

  return parts.map((part, index) => {
    const strongMatch = part.match(/^<strong>(.*?)<\/strong>$/i);

    return strongMatch ? (
      <strong key={`${strongMatch[1]}-${index}`}>{strongMatch[1]}</strong>
    ) : (
      <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>
    );
  });
}
